import moment from 'moment';
import React from 'react';
// Allotment of ISBN and ISSN Number
const ThirteenStepTemplate = ({ values }) => {
  const {
    client_name,
    conference_short_name,
    conference_from_date,
    conference_to_date,
    registration_link,
    your_name,
    contact_details,
  } = values;
  return (
    <div>
      <p>{client_name ? `Hi ${client_name}` : `Hi [Recipient's Name],`}</p>
      <p>
        We’re thrilled to share some great news!{' '}
        <strong>ISBN and ISSN numbers </strong> are now available for our
        upcoming{' '}
        <strong>
          {' '}
          {conference_short_name
            ? conference_short_name
            : `[Conference Short Name]`}{' '}
        </strong>
        , taking place on{' '}
        {conference_from_date && conference_to_date
          ? `${conference_from_date} - ${conference_to_date}`
          : `[Conference from and to Dates]`}{' '}
        .
      </p>

      <p>
        This is a fantastic opportunity to:
        <br />✅ Give your research <strong>global recognition</strong> and
        enhance its visibility
        <br />✅ Secure <strong>prestigious accreditation</strong> for your work
        <br />✅ Get selected papers published in{' '}
        <strong>
          high-impact journals indexed in Scopus and Web of Science (WoS)
        </strong>
        , boosting the reach and credibility of your research
      </p>

      <p>
        Additionally, our conference is <strong>CPD accredited</strong>,
        offering valuable professional development opportunities.
      </p>
      <p>
        <strong>Slots for securing an ISBN or ISSN are limited</strong>, so we
        encourage you to register as soon as possible to take advantage of this
        exclusive benefit.
      </p>
      <p>
        {registration_link ? (
          <>
            <strong>👉 Register Now: </strong>
            <a
              href={registration_link}
              target="_blank"
              rel="noopener noreferrer"
            >
              Click Here
            </a>
          </>
        ) : (
          <strong>👉 Register Now: [Registration Link]</strong>
        )}
      </p>

      <p>
        If you have any questions or need assistance, feel free to reach out. We
        look forward to seeing you at the conference!
      </p>

      <div>
        <strong>Best regards,</strong>
      </div>
      <div>{your_name ? your_name : '[Your Name]'}</div>
      <div>{contact_details ? contact_details : '[Contact details]'}</div>
    </div>
  );
};

export default ThirteenStepTemplate;
